import axios from 'axios';
export async function getControl(assessment: string, category?: string, subcategory?:string, control?: string) {
    let url = process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/"+assessment+"/control";
        
    if(control) {
        url += "/"+category+"/"+subcategory+"/"+control;
    } else if(category && subcategory) {
        url += "/"+category+"/"+subcategory+"/0";
    }  else if(category) {
        url += "/"+category+"/0/0";
    } 

    let response = await axios.get(url);
    return response.data;
}

export async function update(control_id: string, data: FormData) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/store-control/"+control_id,data);
    return response.data;
}

export async function exportQuestionnaire(assessment_id: string) {

    let response = await axios.post(
        process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/"+assessment_id+"/export",
        {
            responseType: 'blob',
        }
    );
    return response.data;
}